import { z } from 'zod';
/**
 * USDA FoodKeeper cold-start shelf-life seed (D6, seed/foodkeeper/README.md).
 * `rawFoodKeeperDatasetSchema` validates the raw dataset export just enough
 * to safely walk it (`sheets[].data[][]`); every individual cell/column is
 * still read defensively by tools/seed/foodkeeper/convert.ts, since the
 * export is known to vary in exact column names and casing.
 * `foodkeeperItemSchema` validates the normalised output consumed by
 * apps/api/src/seed/foodkeeper.ts.
 */
export const rawFoodKeeperDatasetSchema = z.object({
    sheets: z
        .array(z
        .object({
        name: z.string(),
        data: z.array(z.array(z.record(z.string(), z.unknown()))).default([]),
    })
        .passthrough())
        .default([]),
});
/** Cap on any single shelf-life value we'll write (mirrors `shelfLifeDaysValue` in ingredients.ts). */
export const FOODKEEPER_MAX_SHELF_LIFE_DAYS = 3650;
export const foodkeeperItemSchema = z.object({
    /** FoodKeeper `Name`, e.g. "Beans, Green Or Wax - Fresh". */
    name: z.string().min(1),
    subtitle: z.string().min(1).nullable(),
    /** Raw comma-separated `Keywords` column, tried as additional match candidates. */
    keywords: z.string().min(1).nullable(),
    /** FoodKeeper category name (informational only; not mapped to `INGREDIENT_CATEGORIES`). */
    category: z.string().min(1).nullable(),
    pantryDays: z.number().int().min(0).max(FOODKEEPER_MAX_SHELF_LIFE_DAYS).nullable(),
    fridgeDays: z.number().int().min(0).max(FOODKEEPER_MAX_SHELF_LIFE_DAYS).nullable(),
    freezerDays: z.number().int().min(0).max(FOODKEEPER_MAX_SHELF_LIFE_DAYS).nullable(),
});
//# sourceMappingURL=foodkeeper.js.map